let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gzNn8")).then(() => parcelRequire('gZH46'));